import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useUploadCompanyFilesMutation } from 'queries/company'
import { useCompanyDetailContextValue } from '../../../context/CompanyDetailProvider'

type UploadCompanyFileFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useUploadCompanyFilesMutation>['mutate']
    reset: ReturnType<typeof useUploadCompanyFilesMutation>['reset']
  }
}

const [Context, useUploadCompanyFileFlowContextValue] =
  createContext<UploadCompanyFileFlowContextState>({
    name: 'UploadCompanyFileFlowContext',
  })

export const UploadCompanyFileFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: companyId },
  } = useCompanyDetailContextValue()
  const { mutate, reset, isPending, isError, error } =
    useUploadCompanyFilesMutation(companyId)

  const value: UploadCompanyFileFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useUploadCompanyFileFlowContextValue }
